import React, { memo } from 'react';

import moment from 'moment/moment';

import { CustomModal } from '@shared/ui';

import cls from './SystemNotificationsModal.module.css';
import { useSystemNotificationsModal } from './useSystemNotificationsModal';

interface SystemNotificationsModalProps {
    classes?: string;
    systemModalContent: {
        content: string;
        header: string;
        date: string;
    };
    isOpen: boolean;
    onHide: () => void;
}

export const SystemNotificationsModal = memo(
    ({ systemModalContent, isOpen, onHide }: SystemNotificationsModalProps) => {
        const {} = useSystemNotificationsModal();

        return (
            <div onClick={(event) => event.stopPropagation()}>
                <CustomModal
                    isOpen={isOpen}
                    onHideModal={onHide}
                    closeButtonClass={cls.closeBtn}
                    contentClasses={cls.customModalContent}
                >
                    <CustomModal.Header>{systemModalContent.header}</CustomModal.Header>
                    <CustomModal.Body width="596px">
                        <div className={cls.date}>
                            {moment(systemModalContent.date).format('DD.MM.YYYY, HH:mm')}
                        </div>
                        <div
                            className={cls.content}
                            dangerouslySetInnerHTML={{ __html: systemModalContent.content }}
                        />
                    </CustomModal.Body>
                </CustomModal>
            </div>
        );
    }
);
